var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.currentPageContacts)?_c('tbody',{staticClass:"table-body"},_vm._l((_vm.currentPageContacts),function(contact,index){return _c('tr',{key:index,staticClass:"table-body-row"},[_c('td',{staticClass:"table-body__checkbox"},[_c('CheckBox',{attrs:{"checked":_vm.isSelectedContact(contact.leadId),"aria-label":`Select the contact for ${contact.firstName} ${contact.lastName}`},on:{"onClick":function($event){return _vm.handleContactSelection(
                        contact.leadId,
                        ...arguments,
                    )}}})],1),_c('td',{staticClass:"table-body__name",attrs:{"title":_vm.truncateModalFields({
            fieldName: `${contact.firstName} ${contact.lastName}`,
            fieldLength: 24,
            attributeName: 'title',
            })}},[_vm._v("\n            "+_vm._s(_vm.truncateModalFields({
                    fieldName: `${contact.firstName} ${contact.lastName}`,
                    fieldLength: 24,
                }))+"\n        ")]),_c('td',{staticClass:"table-body__email",attrs:{"data-test":"email","title":_vm.truncateModalFields({
            fieldName: `${contact.email}`,
            fieldLength: 24,
            attributeName: `title`,
            })}},[_vm._v("\n            "+_vm._s(_vm.truncateModalFields({
                fieldName: `${contact.email}`,
                fieldLength: 24,
               }))+"\n        ")])])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }